import React,{ useState, useEffect, useRef } from 'react';
import MaterialTable from 'material-table';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from 'common';
import { useTranslation } from "react-i18next";
import {colors} from '../components/Theme/WebTheme';
import { downloadCsv } from '../common/sharedFunctions';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate,useLocation } from 'react-router-dom';
import BlankTable from 'components/BlankTable';
import AlertDialog from 'components/AlertDialog';

export default function Users() {
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings);
  const {
    revokeUserTokens,
    fetchUsersOnce
  } = api;
  const [data, setData] = useState([]);
  const staticusers = useSelector(state => state.usersdata.staticusers);
  const dispatch = useDispatch();
  const loaded = useRef(false);
  const countries = useSelector(state => state.countrylistdata.countries);
  const [countryList, setCountryList] = useState();
  const navigate = useNavigate();
  const {state} = useLocation();
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });

  useEffect(()=>{
    if(countries){
      let list = {};
      for(let i=0; i<countries.length; i++){
        let obj = countries[i];
        list[obj.country] = obj.country
      }
      setCountryList(list);
    }
  },[countries])

  useEffect(()=>{
    dispatch(fetchUsersOnce());
},[dispatch,fetchUsersOnce]);

  useEffect(()=>{
    if(staticusers){
      setData(staticusers.filter(user => user.usertype ==='admin').map(user => ({...user})));
    }else{
      setData([]);
    }
    loaded.current = true;
  },[staticusers]);

  const columns = [
    { title: t('first_name'), field: 'firstName', initialEditValue: ''},
    { title: t('last_name'), field: 'lastName', initialEditValue: '', },
    { title: t('mobile'), field: 'mobile', editable:'onAdd',render: rowData => settings.AllowCriticalEditsAdmin ?rowData.mobile : "Hidden for Demo"},
    { title: t('email'), field: 'email', editable:'onAdd',render: rowData => settings.AllowCriticalEditsAdmin ?rowData.email : "Hidden for Demo",},
    { title: t('profile_image'), field: 'profile_image', render: rowData => rowData.profile_image?<img alt='Profile' src={rowData.profile_image} style={{width: 50,borderRadius:'50%'}}/>:<AccountCircleIcon sx={{ fontSize: 50 }} />, editable:'never',},
    {title: t('country'), field: 'country', lookup: countryList, editable:'onAdd'}
  ];

  const [selectedRow, setSelectedRow] = useState(null);

  const [currentPage, setCurrentPage] = useState(0); 

  useEffect(()=>{
   setCurrentPage(state?.pageNo)
  },[state])

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };


const handlePaginationChange = (page) => {
  setCurrentPage(page)
};

const options={
  initialPage:state?.pageNo ||0,
  pageSize: 10,
    pageSizeOptions: [10, 15, 20],
  exportCsv: (columns, data) => {
    let hArray = [];
    const headerRow = columns.map(col => {
      if (typeof col.title === 'object') {
        return col.title.props.text;
      }
      hArray.push(col.field);
      return col.title;
    });
    const dataRows = data.map(({ tableData, ...row }) => {
      row.createdAt = new Date(row.createdAt).toLocaleDateString() + ' '+ new Date(row.createdAt).toLocaleTimeString()
      let dArr = [];
      for(let i=0;i< hArray.length; i++) {
        dArr.push(row[hArray[i]]);
      }
      return Object.values(dArr);
    })
    const { exportDelimiter } = ",";
    const delimiter = exportDelimiter ? exportDelimiter : ",";
    const csvContent = [headerRow, ...dataRows].map(e => e.join(delimiter)).join("\n");
    const csvFileName = 'download.csv';
    downloadCsv(csvContent, csvFileName);
  },
  exportButton: {
    csv: settings.AllowCriticalEditsAdmin,
    pdf: false,
  },
  maxColumnSort: "all_columns",
  rowStyle: rowData => ({
    backgroundColor: (selectedRow === rowData.tableData.id) ?  colors.THIRDCOLOR: colors.WHITE
  }),
  editable:{
    backgroundColor: colors.WHITE,
    fontSize: "0.8em",
    fontWeight: 'bold ',
    fontFamily: 'Lucida Console", "Courier New", monospace'
  },
  headerStyle: {
    position: "sticky",
    top: "0px",
    backgroundColor: colors.SECONDARY,
    color: colors.WHITE,
    fontSize: "0.8em",
    fontWeight: 'bold ',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    border: `1px solid rgba(224, 224, 224, 1)`,
    textAlign: "center",
  },
  cellStyle: {
    border: `1px solid rgba(224, 224, 224, 1)`,
    textAlign: "center",
  },
  actionsColumnIndex: -1,
}
const localization={body:{
  addTooltip: (t('add')),
  deleteTooltip: (t('delete')),
  editTooltip: (t('edit')),
  emptyDataSourceMessage: (
    (t('blank_message'))
),
editRow: { 
  deleteText: (t('delete_message')),
  cancelTooltip: (t('cancel')),
  saveTooltip: (t('save')) 
    },
  },
  toolbar: {
    searchPlaceholder: (t('search')),
    exportTitle: (t('export')),
  },
  header: {
    actions: (t('actions')) 
},
pagination: {
  labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
  firstTooltip: (t('first_page_tooltip')),
  previousTooltip: (t('previous_page_tooltip')),
  nextTooltip: (t('next_page_tooltip')),
  lastTooltip: (t('last_page_tooltip'))
},
}
  return (
    !loaded.current? <CircularLoading/>:
    <>
   {data && data.length > 0 ? 
    <MaterialTable
      title={t('alladmin')}
      onChangePage={(page, pageSize) => handlePaginationChange(page)}
      columns={columns}
      style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr', borderRadius: "8px", boxShadow: `4px 4px 6px ${colors.SECONDARY}`, }}
      data={data}
      onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
      options={options}
      localization={localization}
      editable={{
        onRowDelete: async (oldData) => {
          try{
            if (settings.AllowCriticalEditsAdmin) {
              await revokeUserTokens(oldData.id);
              return new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  if(oldData.id === 'admin0001'){
                    alert(t('first_admin_deleted'));
                  }else{
                    dispatch(fetchUsersOnce());
                  }
                }, 600);
              });
            } else {
              return new Promise((resolve) => {
                setTimeout(() => {
                  setCommonAlert({ open: true, msg: t('demo_mode') });
                  resolve();
                }, 600);
              });
            }
          }catch(error){
            console.log("error in deletion", error);
          }
        },
      }}

      actions={[
        {
          icon: 'add',
          tooltip: t("add_admin"),
          isFreeAction: true,
          onClick: (event) => navigate( '/users/addadmin',  { state: { pageNo: currentPage }} ),
          
        },
        {
          icon: 'edit',
          tooltip: t("edit"),
          onClick: (event,rowData) =>navigate(`/users/adminupdate/${rowData.id}`,  { state: { pageNo: currentPage }} )
        },
        
       
      ]}
    />
    :<BlankTable  title={t('alladmin')} columns={columns}  data={[]} options={options}
      localization={localization}  
      actions={[
        {
          icon: 'add',
          tooltip: t("add_admin"),
          isFreeAction: true,
          onClick: (event) => navigate( '/users/addadmin',  { state: { pageNo: currentPage }} ),
          
        },
       
      ]}
    />
      }
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </>
  );
}
